import { navigate } from 'gatsby'
import { BLOCK_MARGIN_TOP } from './constants'

// const isIE = /*@cc_on!@*/false || !!document.documentMode
export const isEdge =
  typeof window !== 'undefined' ? !!window.StyleMedia : false

export const isEmpty = obj => Object.keys(obj).length === 0

export const paginationChange = page => {
  if (isEdge) {
    document.getElementById('ContentRegion').scrollIntoView()
  } else {
    document.getElementById('ContentRegion').scrollTo({ top: 0 })
  }
  navigate(`?page=${page}`)
}

export const sliceBottomPadding = padding => {
  if (padding === undefined || padding === null || padding === '100%') {
    return `${BLOCK_MARGIN_TOP}px`
  }
  const paddingMultiplier = Number(padding.replace('%', '')) / 100
  return `${BLOCK_MARGIN_TOP * paddingMultiplier}px !important`
}
